/**
    * for returning item that are placed
    * 
    * Author: Aparna
    * 
    * */
/**
 * PS_RTV3
 * importing action,store and SDIconstants,translation, jquery,component router
 * */
import React, { Component } from 'react';
import * as $ from 'jquery';
import * as MenuAction from '../actions/MenuAction';
import * as RTVAction from '../actions/RTVAction';
import RTVStore from '../stores/RTVStore';
import SDIConstants from '../SDIConstants';
import * as CookieService from '../CookieService';
import { withTranslation, Trans } from 'react-i18next'
import ReactPaginate from 'react-paginate';
import DatePicker from "react-datepicker";
import swal from 'sweetalert';
import { parse } from 'date-fns/esm/fp';

let currentPagePath;
class RTVComponent extends Component {
    /**
     * 
     * PS_RTV5
     * 
     */
    constructor(props) {
        super(props);
        this.Applyfilter = this.Applyfilter.bind(this);
        this.SaveRTVResponse = this.SaveRTVResponse.bind(this);
        this.SaveRTV = this.SaveRTV.bind(this);

        this.state = {
            GridData: [],
            PageNo: "1",
            SearchBy: "PO ID",
            ItemID: "",
            LineDetails: [],
            ReturnPODetails: [],
            isFavorited: false,
            PageCount: 0,
            totalCount: 0,
            itemCount: 10
        }
    }
    /**
     * PS_RTV6
     * */
    componentDidMount() {
        CookieService.updateLocalStorageValues("Session_PageName", window.location.pathname);
        currentPagePath = this.props.location.pathname;
        currentPagePath = currentPagePath.indexOf("?") >= 0 ? currentPagePath.split("?")[0] : currentPagePath;
        let cribID = CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT");
        if (cribID == undefined || cribID == null || cribID.trim() == "") {
            if (CookieService.getLocalStorageValues("HideMobility") && CookieService.getLocalStorageValues("HideMobility").toUpperCase() == "TRUE") {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "No crib has been selected. Please contact the admin/manager to assign a crib"
                });
                this.props.history.push({
                    pathname: `/homepage`
                });
            }
            else {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "Please select crib from user profile"
                });
                this.props.history.push({
                    pathname: `/profile`,
                    state: { origin: 'Inventory' }
                });
            }
            return;
        }
        let getFavPageBO = {
            Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
            pageURL: currentPagePath.toLowerCase(),
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
        };
        RTVAction.getCurrentFavPage(getFavPageBO);
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        RTVStore.on('PageLoad', this.PageLoadResponse.bind(this));
        RTVStore.on('Save', this.SaveRTVResponse.bind(this));
        RTVStore.on('favpage', this.loadFavPageResponse.bind(this));
        RTVStore.on('updateFavPage', this.updateFavPageResponse.bind(this));

    }
    loadFavPageResponse = () => {
        let favPageResponse = JSON.parse(RTVStore.currentFavPageResponse);
        if (favPageResponse.length > 0) {
            favPageResponse = favPageResponse[0];
            this.setState({ isFavorited: true, Page_ID: favPageResponse.PAGE_ID });
        };
    };
    updateFavPageResponse = () => {
        if (RTVStore.updateFavPageResponse.updateType == 1) {
            let response = JSON.parse(RTVStore.updateFavPageResponse.responseStr)[0];
            if (response.is_Success == "True") {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                this.setState({ isFavorited: true, Page_ID: response.Page_ID });
                MenuAction.toastMessage(1);
            }
        } else {
            let response = JSON.parse(RTVStore.updateFavPageResponse.responseStr)[0];
            if (response.success == "true") {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                this.setState({ isFavorited: false });
                MenuAction.toastMessage(2);
            }
        }
        //this.refreshMenu();
    };
    handleFavorite = (event) => {
        this.setState({ isFavorited: event.target.checked });
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        if (event.target.checked == true) {
            let insertFavPageBO = {
                Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
                pageURL: currentPagePath.toLowerCase(),
                pageTitle: "RTV",
                Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
            }
            RTVAction.insertFavPage(insertFavPageBO)
        } else {
            let deleteFavPageBO = {
                Page_ID: this.state.Page_ID
            }
            RTVAction.deleteFavPage(deleteFavPageBO)
        }
    };

    /**
     * PS_RTV
     * */
    componentWillUnmount() {
        RTVStore.removeListener('PageLoad', this.PageLoadResponse.bind(this));
        RTVStore.removeListener('Save', this.SaveRTVResponse.bind(this));
        RTVStore.removeListener('favpage', this.loadFavPageResponse.bind(this));
        RTVStore.removeListener('updateFavPage', this.updateFavPageResponse.bind(this));
    }

    /**
     * PS_RTV
     * */
    SaveRTVResponse = () => {
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        this.setState({ GridData: [], PageNo: "1", SearchBy: "PO ID", ItemID: "", LineDetails: [], ReturnPODetails: [], isFavorited: false, PageCount: 0, totalCount: 0, SearchCriteria: "" })

    }

    SaveRTV = (index) => {

        let valid = true
        let POList = []
        let line = this.state.LineDetails[index]
        let header = this.state.ReturnPODetails.filter((x) => x.RECEIVER_ID == line.RECEIVER_ID && x.RECV_LN_NBR == line.RECV_LN_NBR)
        if (parseInt(line.RTVQty) == "0" || line.RTVQty == "" || line.RTVQty == undefined) {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Please enter Return qty"
            });
            // alert("Please enter qty")
            valid = false
            return;
        }
        else {
            let RTVQty = parseFloat(line.RTVQty);
            let POQty = parseFloat(line.QTY_PO);
            let RcvQty = parseFloat(line.QTY_SH_NETRCV_VUOM);
            if (RTVQty > POQty) {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "RTV Qty > PO Qty"
                });
                //  alert("RTV Qty > PO Qty")
                valid = false
                return;
            }
            if (RTVQty > RcvQty) {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "RTV Qty > Rcv Qty"
                });
                //    alert("RTV Qty > Rcv Qty")
                valid = false
                return;
            }

        }

        if ((line.RejActionDT == "" || line.RejActionDT == " ")) {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Please select Rej Action"
            });
            // alert("Please select action")
            valid = false
            return;
        }
        if ((line.RejReasonDT == "" || line.RejReasonDT == " ")) {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Please select Rej Reason"
            });
            // alert("Please select reason")
            valid = false
            return;
        }
        if (valid) {
            let PoItemList = {
                USER_ID: CookieService.getLocalStorageValues("Session_UserID"),
                BUSINESS_UNIT_PO: 'WAL00',
                VENDOR_ID: header[0].VENDOR_ID,
                VENDOR_LOC: line.VNDR_LOC,
                BUYER_ID: line.Buyer_ID,
                FREIGHT_TERM: line.FreightDT,
                STORAGE_LOC: line.BinLocDT,
                PO_ID: header[0].RECV_PO_ID,
                RECEIVER_ID: header[0].RECEIVER_ID,
                RECV_LN_NBR: header[0].RECV_LN_NBR,
                REJ_ACTION: line.RejActionDT,
                RMA_ID: line.vnd_RMA_Num,
                QTY: line.RTVQty,
                SHIP_TYPE: line.ShipviaDT,
                CARRIER_ID: line.CarrierDT,
                REQUEST_DT: line.ReqDate,
                REJ_REASON: line.RejReasonDT
            };
            POList.push(PoItemList);
            let PO = { "PoItemList": POList };
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            RTVAction.SaveRTVAction(PO);
        }






    }
    clearItemId = (type) => {
        if (type == "SearchCriteria") {
            this.setState({ SearchCriteria: "" });
        }
        if (type == "ItemID") {
            this.setState({ ItemID: "" });
        }
    }

    OnHandleChange = (e, name, select) => {
        const regex = SDIConstants.alphanumericRegex
        const value = e.target.value;

        switch (name) {
            case "SearchBy": {
                e.preventDefault();
                this.setState({ [name]: select })
                if (e.target.value) {
                    if (e.target.value.length <= 9) {
                        this.setState({ LineDetails: [], ReturnPODetails: [] });
                    }
                }


                break;
            }
            case "SearchCriteria": case "ItemID": {
                e.preventDefault();
                this.setState({ [name]: e.target.value })
                if (e.target.value) {
                    if (e.target.value.length <= 9) {
                        this.setState({ LineDetails: [], ReturnPODetails: [] });
                    }
                }
                  
                break;
            }

        }

    }

    ClearSearch = (name) => {
        this.setState({ [name]: "" })
    }


    keyPressQTY(e) {
        const invalidChars = [".", "-", "+", "e", "/", "!", "@", "#", "$", "%", "^", "&", "*", "(", ")", "="];
        if (invalidChars.includes(e.key)) e.preventDefault();
    };



    /**
     * PS_RTV
     * */
    Applyfilter = () => {
        //if (this.state.ItemID == "" && this.state.SearchCriteria == "") {
        //    swal({
         //       allowOutsideClick: false,
         //       closeOnClickOutside: false,
         //       text: "Select any criteria"
         //   });
        if (!this.state.SearchCriteria) {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Please enter a PO ID or Recv.no"
            });
            //alert("Select any criteria")
            return;
        }

            // Regression Bug- 5466 - K. Surya - RTV panel-Validation message should be modified- While apply filter.
            let sby = "0"
            if (this.state.SearchBy == "Recv No") {
                sby = "1"
            }
            debugger
            let siteBU = "";
            if (CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT") != "" && CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT") != undefined) {
                siteBU = CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT");
            }
            let BO = {
                SearchCriteria: this.state.SearchCriteria,
                dropSearchBy: sby,
                InvItmID: this.state.ItemID,
                SiteBU: siteBU,
                PageNo: this.state.PageNo,
                ItemCount: this.state.itemCount
            }
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            RTVAction.RTVPageLoadAction(BO);
    }
    /**
     * PS_RTV
     * */
    PageLoadResponse = () => {

        let Response = JSON.parse(RTVStore.PageLoadData);
        console.log("RTVResponse", Response)
        let locLineDetails = [];
        let locReturnPODetails = [];
        let locCarrierDT = [];
        let locFreightDT = [];
        let locRejActionDT = [];
        let locRejReasonDT = [];
        let locShipviaDT = [];
        let locBinLocDT = [];
        let count = 0;
        if (Response.LineDetails != "" && Response.LineDetails != undefined && Response.LineDetails != null) {
            locLineDetails = Response.LineDetails
            let today = new Date();
            locLineDetails.forEach((value) => {
                value.CarrierDT = "";
                value.FreightDT = "";
                value.RejActionDT = "";
                value.RejReasonDT = "";
                value.ShipviaDT = "";
                value.BinLocDT = "";
                value.RTVQty = "";
                value.ReqDate = today
                value.vnd_RMA_Num = "";
                value.comments = ""
            });
        }
        if (Response.ReturnPODetails != "" && Response.ReturnPODetails != undefined && Response.ReturnPODetails != null) {
            locReturnPODetails = Response.ReturnPODetails
            count = parseFloat(Response.ReturnPODetails.length) / 10
            if (Response.ReturnPODetails.length > 0) {
                if (Response.CarrierDT != "" && Response.CarrierDT != undefined && Response.CarrierDT != null) {
                    locCarrierDT = Response.CarrierDT
                }
                if (Response.FreightDT != "" && Response.FreightDT != undefined && Response.FreightDT != null) {
                    locFreightDT = Response.FreightDT
                }
                if (Response.RejActionDT != "" && Response.RejActionDT != undefined && Response.RejActionDT != null) {
                    locRejActionDT = Response.RejActionDT
                }
                if (Response.RejReasonDT != "" && Response.RejReasonDT != undefined && Response.RejReasonDT != null) {
                    locRejReasonDT = Response.RejReasonDT
                }
                if (Response.ShipviaDT != "" && Response.ShipviaDT != undefined && Response.ShipviaDT != null) {
                    locShipviaDT = Response.ShipviaDT
                }
                if (Response.BinLocDT != "" && Response.BinLocDT != undefined && Response.BinLocDT != null) {
                    locBinLocDT = Response.BinLocDT
                }
                let tot = 0;

                if (Response.TotalCount != "" && Response.TotalCount != undefined && Response.TotalCount != null) {
                    tot = Response.TotalCount[0].TOTAL_COUNT
                }

                this.setState({
                    ReturnPODetails: locReturnPODetails, LineDetails: locLineDetails, CarrierDT: locCarrierDT, FreightDT: locFreightDT,
                    RejActionDT: locRejActionDT, RejReasonDT: locRejReasonDT, ShipviaDT: locShipviaDT, BinLocDT: locBinLocDT,
                    totalCount: tot, PageCount: Math.ceil((tot > 0 ? tot : 0) / this.state.itemCount)
                });
            }
            else {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "Please enter a valid PO ID or Recv.no"
                });
                //alert("Please enter a valid PO ID or Recv.no");
                this.setState({ GridData: [], PageNo: "1", SearchBy: "PO ID", ItemID: "", LineDetails: [], ReturnPODetails: [], isFavorited: false, PageCount: 0, totalCount: 0, SearchCriteria: "" })
            }
        }
        else {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Please enter a valid PO ID or Recv.no"
            });
            // alert("Please enter a valid PO ID or Recv.no");
            this.setState({ GridData: [], PageNo: "1", SearchBy: "PO ID", ItemID: "", LineDetails: [], ReturnPODetails: [], isFavorited: false, PageCount: 0, totalCount: 0, SearchCriteria: "" })
        }

    }

    handlePageClick = (data) => {

        let pageNo = data.selected + 1;
        let sby = "0"
        if (this.state.SearchBy == "Recv No") {
            sby = "1"
        }
        this.setState({ PageNo: pageNo });
        let BO = {
            SearchCriteria: this.state.SearchCriteria,
            dropSearchBy: sby,
            InvItmID: this.state.ItemID,
            //pass crib id instead of 'W01'
            SiteBU: CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT"),
            PageNo: pageNo,
            ItemCount: this.state.itemCount
        }
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        RTVAction.RTVPageLoadAction(BO);
    };

    handleChngRTVQty = (index, values) => {
        let LnDetail = this.state.LineDetails;
        let POQty = LnDetail[index].QTY_PO
        let RecvQty = LnDetail[index].QTY_SH_NETRCV_VUOM
        if ((parseFloat(values.target.value) <= parseFloat(POQty) && parseFloat(values.target.value) <= parseFloat(RecvQty)) ? LnDetail[index].RTVQty = values.target.value : LnDetail[index].RTVQty = "0");
        this.setState({ LineDetails: LnDetail })
    }

    onAccordianClick = (event, index) => {
        // Toggle the arrow icon for the clicked accordion
        $(event.currentTarget).children().toggleClass('accordion-arrow-change');

        // Toggle the visibility of the clicked accordion's content
        $(`#contentrow-${index}`).toggleClass('d-none');

        // Close all other accordions
        this.state.ReturnPODetails.forEach((value, idx) => {
            if (index !== idx) {
                // Make sure other accordions are closed
                $(`#contentrow-${idx}`).addClass('d-none');
                $(`#arrow-${idx}`).removeClass('accordion-arrow-change');
            }
        });

        // Remove the border from all table rows
        $('tr').removeClass('tr-border');

        // Add the border to the parent row of the clicked accordion if it's not hidden
        if (!$(`#contentrow-${index}`).hasClass('d-none')) {
            $(event.currentTarget).parent('tr').addClass('tr-border');
        }
    };
    CarrierDD = () => {
        return this.state.CarrierDT.map((value, index) => {
            return (
                <option value={value.CARRIER_ID}>{value.DESCR}</option>
            )
        })
    }
    FreightDD = () => {

        return this.state.FreightDT.map((value, index) => {
            return (
                <option value={value.FREIGHT_TERMS}>{value.DESCR}</option>
            )
        })
    }
    RejActionDD = () => {
        return this.state.RejActionDT.map((value, index) => {
            return (
                <option value={value.FIELDVALUE}>{value.XLATLONGNAME}</option>
            )
        })
    }
    RejReasonDD = () => {
        return this.state.RejReasonDT.map((value, index) => {
            return (
                <option value={value.RETURN_REASON}>{value.DESCR50}</option>
            )
        })
    }
    ShipviaDD = () => {
        return this.state.ShipviaDT.map((value, index) => {
            return (
                <option value={value.SHIP_TYPE_ID}>{value.DESCR}</option>
            )
        })
    }
    BinLocDD = (id) => {
        if (id != undefined && id != null && id != "") {
            let dd = this.state.BinlocDD.filter((x) => x.INV_ITEM_ID == id)

            return this.state.dd.map((value, index) => {
                return (
                    <option value={value.SHIP_TYPE_ID}>{value.DESCR}</option>
                )
            })
        }
        else {
            return (
                <option value="2">Default Location</option>
            )
        }

    }
    handleGridChange = (e, value, index) => {
        let label = e.target.name
        const re = SDIConstants.quantityRegEX;
        if (e.target.name == "RTVQty") {

            if (e.target.value === '' || re.test(e.target.value)) {
                //let { GridData } = this.state;
                let LineDetails = [...this.state.LineDetails];
                LineDetails[index] = { ...LineDetails[index], [e.target.name]: e.target.value };
                this.setState({ LineDetails });
                console.log("handleGridChange", LineDetails)

            }
        }
        else {
            let LineDetails = [...this.state.LineDetails];
            LineDetails[index] = { ...LineDetails[index], [e.target.name]: "" };
            this.setState({ LineDetails });
            console.log("handleGridChange", LineDetails)
        }
    }
    gridchange = (e, value, index) => {

        let label = e.target.name
        let RegExp = /^\d*\.?\d*$/;
        if (e.target.name == "RTVQty" || e.target.name == "vnd_RMA_Num") {

            if (e.target.value === '' || RegExp.test(e.target.value)) {
                //let { GridData } = this.state;
                let LineDetails = [...this.state.LineDetails];
                LineDetails[index] = { ...LineDetails[index], [e.target.name]: e.target.value };
                this.setState({ LineDetails });
                console.log("handleGridChange", LineDetails)

            }
        }
        else {
            let LineDetails = [...this.state.LineDetails];
            LineDetails[index] = { ...LineDetails[index], [e.target.name]: e.target.value };
            this.setState({ LineDetails });
            console.log("handleGridChange", LineDetails)
        }
    }
    /**
     * PS_RTV
     * */
    handleDatePicker = (date, name, index) => {

        // let dateOL = this.handledate(date);
        let LineDetails = [...this.state.LineDetails];
        LineDetails[index] = { ...LineDetails[index], [name]: date };
        this.setState({ LineDetails });

    };
    //handlePageClick = (e) => {
    //    let pageNo = e.selected + 1;
    //    this.setState({ PageNo: pageNo });
    //}
    linddetail = (Parent) => {

        console.log("Parent", Parent)
        return this.state.LineDetails.map((value, index) => {
            if (value.RECEIVER_ID == Parent.RECEIVER_ID && value.RECV_LN_NBR == Parent.RECV_LN_NBR) {
                return (
                    <tr className="p">
                        <td colSpan={12} className="hiddenRow">
                            <div className="accordian-body  py-1 mt-3 ml-4 pl-2" id="order-row-1">

                                <div className="row mx-0 pb-0">
                                    <div className="col-md-12 pl-4 mb-1">
                                        {/*2/24/22, WBW - 32, Dhevanesam R*/}
                                        <div className="row">
                                            <div className="col-md-3 pr-0 mb-2">
                                                <label className="catalog-label mr-2">PO Ln:</label>
                                                <label className="item-details-value">{Parent.LINE_NBR}</label>
                                            </div>
                                            <div className="col-md-3 pr-0 mb-2">
                                                <label className="catalog-label mr-2">PO Sched:</label>
                                                <label className="item-details-value">{Parent.SCHED_NBR}</label>
                                            </div>
                                            <div className="col-md-3 pr-0 mb-2">
                                                <label className="catalog-label mr-2">Avail Qty:</label>
                                                <label className="item-details-value">{value.QtyOnHand}</label>
                                            </div>
                                            <div className="col-md-3 pr-0 mb-2">
                                                <label className="catalog-label mr-2">Vendor ID:</label>
                                                <label className="item-details-value">{Parent.VENDOR_ID}</label>
                                            </div>
                                            <div className="col-md-3 pr-0 mb-2">
                                                <label className="catalog-label mr-2">Short Name:</label>
                                                <label className="item-details-value">{value.Vend_ShrtName}</label>
                                            </div>
                                            <div className="col-md-3 pr-0 mb-2">
                                                <label className="catalog-label mr-2">Buyer :</label>
                                                <label className="item-details-value">{value.Buyer_ID}</label>
                                            </div>
                                            <div className="col-md-3 pr-0 mb-2">
                                                <label className="catalog-label mr-2">Item ID:</label>
                                                <label className="item-details-value">{Parent.INV_ITEM_ID}</label>
                                            </div>
                                            <div className="col-md-3 pr-0 mb-2">

                                                <div className="col-md-12 float-left mb-0 p-0 ssd">
                                                    <label className="catalog-label mt-2 mb-0"><Trans>Req Date</Trans><span>:</span></label>
                                                    <div className="col-md-6 float-left">

                                                        <DatePicker className="form-control place"
                                                            id="stFrom"
                                                            fixedHeight
                                                            placeholderText="MM/DD/YYYY"
                                                            dateFormat="MM/dd/yyyy"
                                                            showMonthDropdown
                                                            showYearDropdown
                                                            selected={value.ReqDate}
                                                            maxDate={this.state.SearchTrToDate}
                                                            onChange={(e) => this.handleDatePicker(e, "ReqDate", index)}
                                                        //value={this.state.FromDate}
                                                        />
                                                    </div>
                                                    <span className="calendar-icon filter-calendar-icon custom-datepicker2 float-left" onClick={() => $(`#stFrom`).focus()} />



                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">

                                            <div className="col-md-3 pr-0 mb-2">
                                                <label className="catalog-label mr-2">Status:</label>
                                                <label className="item-details-value">Open</label>
                                            </div>
                                            <div className="col-md-3 pr-0 mb-2">
                                                <label className="catalog-label mr-2">Vnd UOM:</label>
                                                <label className="item-details-value" style={{ marginLeft: "-2%" }}>{Parent.UNIT_OF_MEASURE}</label>
                                            </div>
                                            <div className="col-md-3 pr-0 mb-2">
                                                <label className="catalog-label mr-2">Ship Qty:</label>
                                                <label className="item-details-value"> {value.SHIPQTY}</label>
                                            </div>
                                            <div className="col-md-3 pr-0 mb-2">
                                                <label className="catalog-label mr-2">Return Qty (Vnd UOM):</label>
                                                <label className="item-details-value"> {value.RETURNQTY92}</label>
                                            </div>

                                        </div>
                                        <div className="row">
                                            <div className="col-md-3 pr-0 mb-2">
                                                <label className="catalog-label mr-2">Price:</label>
                                                <label className="item-details-value ">{value.PRICE_PO}</label>
                                            </div>
                                            <div className="col-md-3 pr-0 mb-2">
                                                <label className="catalog-label mr-2">Amount:</label>
                                                <label className="item-details-value">{value.AMOUNT}</label>
                                            </div>
                                            <div className="col-md-3 pr-0 mb-2">
                                                <label className="catalog-label mr-2">Conversion Rate:</label>
                                                <label className="item-details-value">{Parent.CONVERSION_RATE}</label>
                                            </div>

                                            <div className="col-md-3 pr-0 mb-2">
                                                <label className="catalog-label mr-2">PO Qty:</label>
                                                <label className="item-details-value">{value.QTY_PO}</label>
                                            </div>

                                        </div>


                                        <div className="row">

                                            <div className="col-md-3 pr-0 mb-2">
                                                <label className="catalog-label mr-2">Recv qty:</label>
                                                <label className="item-details-value ">{value.QTY_SH_NETRCV_VUOM}</label>
                                            </div>
                                            <div className="col-md-3 pr-0 mb-2">
                                                <label className="catalog-label mr-2">Recv ln:</label>
                                                <label className="item-details-value">{Parent.RECV_LN_NBR} </label>
                                            </div>
                                            <div className="col-md-3 pr-0 mb-2">
                                                <label className="catalog-label mr-2"><Trans>Recv Sched</Trans><span> :</span></label>
                                                <label className="item-details-value">{value.RECV_SHIP_SEQ_NBR} </label>

                                            </div>
                                            <div className="col-md-3 pr-0 mb-2">
                                                <label className="catalog-label mr-2"><Trans>Recv Dist sched</Trans><span> :</span></label>
                                                <label className="item-details-value">{value.DISTRIB_LINE_NUM} </label>

                                            </div>

                                        </div>
                                        <div className="row">

                                            <div className="col-md-3 float-left mb-3">

                                                <label className="catalog-label mt-2 mb-0"><Trans>Freight Trm:</Trans></label>

                                                <div className="col-md-6 float-left">
                                                    <select className="form-control" name="FreightDT" value={value.FreightDT} onChange={(e) => this.gridchange(e, value, index)}>
                                                        {/*<option value="">Select </option>*/}
                                                        <option value="COLL 3RD">UPS Collect 3rd Party 9R5V94</option>
                                                        {this.FreightDD()}


                                                    </select>
                                                    <label className="catalog-label mt-2 mb-0 d-none" value={value.FreightDT} id={`FreightDT-${index}`}><Trans>Freight Trm</Trans></label>

                                                </div>
                                            </div>
                                            <div className="col-md-3 float-left mb-3">

                                                <label className="catalog-label mt-2 mb-0 mandatory-after"><Trans>Rej Action</Trans><span>:</span></label>

                                                <div className="col-md-6 float-left">
                                                    <select className="form-control" name="RejActionDT" value={value.RejActionDT} onChange={(e) => this.gridchange(e, value, index)}>
                                                        {/*<option value="">Select </option>*/}
                                                        <option value="">Select</option>
                                                        {this.RejActionDD()}

                                                    </select>
                                                    <label className="catalog-label mt-2 mb-0 d-none" value={value.RejActionDT} id={`RejActionDT-${index}`}><Trans>Rej Action</Trans></label>

                                                </div>
                                            </div>
                                            <div className="col-md-3 float-left mb-3">

                                                <label className="catalog-label mt-2 mb-0 mandatory-after"><Trans>Rej Reason</Trans><span>:</span></label>

                                                <div className="col-md-6 float-left">
                                                    <select className="form-control " name="RejReasonDT" value={value.RejReasonDT} onChange={(e) => this.gridchange(e, value, index)}>
                                                        {/*<option value="">Select </option>*/}
                                                        <option value="">Select</option>
                                                        {this.RejReasonDD()}

                                                    </select>
                                                    <label className="catalog-label mt-2 mb-0 d-none" value={value.RejReasonDT} id={`RejReasonDT-${index}`}><Trans>Rej Reason</Trans></label>

                                                </div>
                                            </div>
                                            <div className="col-md-3 float-left mb-3">

                                                <label className="catalog-label mt-2 mb-0"><Trans>Ship via</Trans><span>:</span></label>

                                                <div className="col-md-6 float-left">
                                                    <select className="form-control" name="ShipviaDT" value={value.ShipviaDT} onChange={(e) => this.gridchange(e, value, index)}>
                                                        {/*<option value="">Select </option>*/}
                                                        <option value="UPS GROUND">UPS Ground</option>
                                                        {this.ShipviaDD()}
                                                    </select>
                                                    <label className="catalog-label mt-2 mb-0 d-none" value={value.ShipviaDT} id={`ShipviaDT-${index}`}><Trans>Ship via</Trans></label>

                                                </div>
                                            </div>


                                        </div>
                                        <div className="row">

                                            <div className="col-md-3 float-left mb-3">

                                                <label className="catalog-label mt-2 mb-0"><Trans>Carrier ID</Trans><span>:</span></label>

                                                <div className="col-md-6 float-left">
                                                    <select className="form-control" name="CarrierDT" value={value.CarrierDT} onChange={(e) => this.gridchange(e, value, index)}>
                                                        {/*<option value="">Select </option>*/}
                                                        <option value="">Select</option>
                                                        {this.CarrierDD()}
                                                    </select>
                                                    <label className="catalog-label mt-2 mb-0 d-none" value={value.CarrierDT} id={`ShipviaDT-${index}`}><Trans>Carrier</Trans></label>

                                                </div>
                                            </div>
                                            {this.state.BinLocDT != undefined && this.state.BinLocDT != null && this.state.BinLocDT != [] ?
                                                <div className="col-md-3 float-left mb-3">

                                                    <label className="catalog-label mt-2 mb-0"><Trans>Store Location</Trans><span>:</span></label>

                                                    <div className="col-md-6 float-left">
                                                        <select className="form-control" name="BinLocDT" value={value.BinLocDT} onChange={(e) => this.gridchange(e, value, index)}>
                                                            {/*<option value="">Select </option>*/}
                                                            <option value="">Select</option>
                                                            {this.BinLocDD()}
                                                        </select>
                                                        <label className="catalog-label mt-2 mb-0 d-none" value={value.BinLocDT} id={`BinLocDT-${index}`}><Trans>Store Location</Trans></label>

                                                    </div>
                                                </div> :
                                                <div className="col-md-3 pr-0 mb-2">
                                                    <label className="catalog-label mr-2"><Trans>Store Location</Trans><span>:</span></label>
                                                    <label className="item-details-value">Default location</label>
                                                </div>}

                                            <div className="col-md-3 pr-0 mb-2">
                                                <label className="mandatory-after catalog-label mt-2 mb-0">Return qty:</label>
                                                <div className="col-md-6 float-left">
                                                    <input type="number" className="form-control" min="0" max={value.QTY_SH_NETRCV_VUOM} value={value.RTVQty|| 0 } style={{ "width": '100%', "marginLeft": "0%", "marginBottom": "-1%" }} id={`rtrnqty` + index} name="RTVQty" onChange={(e) => this.handleChngRTVQty(index, e)} />
                                                </div>
                                            </div>


                                            <div className="col-md-3 pr-0 mb-2">
                                                <label className="catalog-label mt-2 mb-0">Vnd RMA num:</label>
                                                <div className="col-md-6 float-left">
                                                    <input type="text" value={value.vnd_RMA_Num} name="vnd_RMA_Num" maxlength="10" onChange={(e) => this.gridchange(e, value, index)} className="form-control float-left mr-2 " />
                                                    <label className="catalog-label mt-2 mb-0 d-none" value={value.vnd_RMA_Num} id={`vnd_RMA_Num-${index}`}><Trans>Vnd RMA num</Trans></label>
                                                </div>
                                            </div>




                                            {/* <label className="catalog-label mt-2 mb-0"><Trans>Storage Location:</Trans></label>

                                        <div className="col-md-6 float-left">
                                            <select className="form-control" name="BinLocDT" value={value.BinLocDT} onChange={(e) => this.gridchange(e, value, index)}>                                                
                                                <option value="1">Select</option>
                                                {this.binloacDD()}
                                            </select>
                                            <label className="catalog-label mt-2 mb-0 d-none" value={value.BinLocDT} id={`BinLocDT-${index}`}><Trans>Storage Location</Trans></label>

                                        </div>*/}
                                        </div>
                                        <div className="row">
                                            <div className="col-md-11 pr-0 mb-2">
                                                <div className="float-right">
                                                    <span className="errorspan1 float-left" style={{ width: "75%" }} id="StatusMsg"></span>
                                                    <button className="btn btn-primary custom-btn-primary primary-btn float-right " onClick={e => this.SaveRTV(index)}><Trans>Save</Trans></button>

                                                </div>
                                            </div>
                                        </div>

                                        {/*  <div className="row">
                                        <div className="col-md-3 pr-0 mb-2">
                                            <label className="catalog-label mr-2">Available Qty:</label>
                                            <label className="item-details-value ">{value.QTY_SH_NETRCV_VUOM}</label>
                                        </div></div>*/}


                                    </div>

                                </div>
                            </div>

                        </td>
                    </tr>
                );
            }
        })
    }

    BindDataGrid = () => {

        return this.state.ReturnPODetails.map((value, index) => {

            return (
                <React.Fragment key={index}>
                    <tr>
                        <td className="text-center">
                        </td>
                        <td className="accordion-toggle" onClick={(e) => this.onAccordianClick(e, index)} >
                            <span className="accordion-arrow header-arrow" id={`arrow-${index}`} />
                        </td>
                        {/* <td className="d-sm-none d-md-table-cell"><div style={{ width: '100px' }}><a href="#" className="order-id" data-toggle="modal" data-backdrop="static" data-keyboard="false" data-target=".orderstatus-popup" onClick={e => this.PopupForLineLevelDetails(index, value, "V")} >{value.NAME1}</a></div></td>*/}

                        {/*<td className="d-none d-sm-none d-md-table-cell" >{value.BUSINESS_UNIT_IN}</td>*/}
                        <td className="d-none d-sm-none d-md-table-cell" >{value.INV_ITEM_ID}</td>
                        <td className="d-none d-sm-none d-md-table-cell" ><div style={{ width: '80px' }}>{value.RECEIVER_ID}</div></td>
                        <td className="d-none d-sm-none d-md-table-cell">{value.RECV_LN_NBR}</td>
                        {/*<td className="d-none d-sm-none d-md-table-cell"><div style={{ width: '80px' }}>{value.BUSINESS_UNIT_PO}</div></td>*/}
                        <td className="d-none d-sm-none d-md-table-cell"><div style={{ width: '50px' }}>{value.PO_ID}</div></td>
                        {/*<td className="d-none d-sm-none d-md-table-cell priority-alert">{value.LINE_PRIOR}</td>*/}
                        {/* <td className="d-none d-sm-none d-md-table-cell">{value.ENTEREDEMPNAME}</td>*/}
                        <td className="d-none d-sm-none d-md-table-cell"><div style={{ width: '50px' }}>{value.LINE_NBR}</div></td>
                        <td className="d-none d-sm-none d-md-table-cell"><div style={{ width: '80px' }}>{value.SCHED_NBR}</div></td>
                        <td className="d-none d-sm-none d-md-table-cell"><div style={{ width: '80px' }}>{value.RECV_PO_ID}</div></td>
                        <td className="d-none d-sm-none d-md-table-cell"><div style={{ width: '80px' }}>{value.VENDOR_ID}</div></td>



                    </tr>
                    <tr className="p d-none content-row" id={`contentrow-${index}`}>
                        <td colSpan="12" style={{ paddingBottom: '0' }}>
                            <div className="accordian-body py-0 px-1" id="order-row-1">
                                <div className="row justify-content-center">
                                    <div className="col-md-12" style={{ marginLeft: '0%' }}>
                                        <table className="table ZEUS_Grid FOM-grid chk-ordertbl" style={{ marginBottom: '0', borderSpacing: '0' }}>
                                            <tbody>

                                                <h4 className="item-details-title mt-2 mb-0 ml-3 pl-5"><Trans>ItemKey</Trans><span> </span><Trans>Details</Trans></h4>

                                                {this.linddetail(value)}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>
                </React.Fragment>

            )
        });
    }
    Canclebutton = () => {
        this.setState({ SearchBy: "PO ID", SearchCriteria: "", ItemID: "", LineDetails: [], ReturnPODetails: [] });
    }

    render() {
        const { t } = this.props;
        return (
            <div>
                {/* Check Order Status starts */}
                <div className="container-fluid content-margin content-section">
                    <div className="row">
                        <div className="col-md-12 page-heading mb-3 ">
                            <h5 className="page-title"><Trans>RTV</Trans></h5>
                            <div className="fav-item-maintenance-icon mt-1">
                                <input type="checkbox" id="checkbox-OrdStatus" className="checknow" name="isFavorited" checked={this.state.isFavorited} onChange={this.handleFavorite} />
                                <label htmlFor="checkbox-OrdStatus">
                                    <svg className="heart-svg" viewBox="467 392 58 57" xmlns="http://www.w3.org/2000/svg">
                                        <g className="Group" fill="none" fillRule="evenodd" transform="translate(467 392)">
                                            <path d="M29.144 20.773c-.063-.13-4.227-8.67-11.44-2.59C7.63 28.795 28.94 43.256 29.143 43.394c.204-.138 21.513-14.6 11.44-25.213-7.214-6.08-11.377 2.46-11.44 2.59z" className="heart" fill="#fff" />
                                            <circle className="main-circ" fill="#E2264D" opacity={0} cx="29.5" cy="29.5" r="1.5" />
                                            <g className="grp7" opacity={0} transform="translate(7 6)">
                                                <circle className="oval1" fill="#9CD8C3" cx={2} cy={6} r={2} />
                                                <circle className="oval2" fill="#8CE8C3" cx={5} cy={2} r={2} />
                                            </g>
                                            <g className="grp6" opacity={0} transform="translate(0 28)">
                                                <circle className="oval1" fill="#CC8EF5" cx={2} cy={7} r={2} />
                                                <circle className="oval2" fill="#91D2FA" cx={3} cy={2} r={2} />
                                            </g>
                                            <g className="grp3" opacity={0} transform="translate(52 28)">
                                                <circle className="oval2" fill="#9CD8C3" cx={2} cy={7} r={2} />
                                                <circle className="oval1" fill="#8CE8C3" cx={4} cy={2} r={2} />
                                            </g>
                                            <g className="grp2" opacity={0} transform="translate(44 6)">
                                                <circle className="oval2" fill="#CC8EF5" cx={5} cy={6} r={2} />
                                                <circle className="oval1" fill="#CC8EF5" cx={2} cy={2} r={2} />
                                            </g>
                                            <g className="grp5" opacity={0} transform="translate(14 50)">
                                                <circle className="oval1" fill="#91D2FA" cx={6} cy={5} r={2} />
                                                <circle className="oval2" fill="#91D2FA" cx={2} cy={2} r={2} />
                                            </g>
                                            <g className="grp4" opacity={0} transform="translate(35 50)">
                                                <circle className="oval1" fill="#F48EA7" cx={6} cy={5} r={2} />
                                                <circle className="oval2" fill="#F48EA7" cx={2} cy={2} r={2} />
                                            </g>
                                            <g className="grp1" opacity={0} transform="translate(24)">
                                                <circle className="oval1" fill="#9FC7FA" cx="2.5" cy={3} r={2} />
                                                <circle className="oval2" fill="#9FC7FA" cx="7.5" cy={2} r={2} />
                                            </g>
                                        </g>
                                    </svg>
                                </label>
                            </div>
                        </div>
                        <div className="col-md-12">
                            {/* <div className="row  mb-3">
                                        <div className="col-md-2 pr-0 mb-3">
                                            <label className="catalog-label"><Trans>Order Date</Trans></label>
                                            <select className="form-control" name="SelectedReport" value={this.state.SelectedReport} onChange={e => this.OnHandleChange(e, "SelectedReport")}>

                                                <option value="X">{t("Select ReportKey")}</option>
                                                <option value="7">{t("Last 7 Days")}</option>
                                                <option value="15">{t("Last 15 Days")}</option>
                                                <option value="30">{t("Last 30 Days")}</option>
                                                <option value="0">{t("This Month")}</option>
                                                <option value="-1">{t("Last Month")}</option>
                                                <option value="99">Search Transaction</option>
                                            </select>
                                        </div>



                                    </div>*/}
                            <div className="row mb-3" >

                                {/* <div className="col-md-3 pr-0 middle-field mb-3" id="sFT" style={{ marginTop: "1%" }}>
                                                <div className="col-md-6 float-left mb-4 p-0 ssd">
                                                    <label className="catalog-label"><Trans>From</Trans></label>
                                                    <DatePicker className="form-control place"
                                                        id="From"
                                                        fixedHeight
                                                        placeholderText="MM/DD/YYYY"
                                                        dateFormat="MM/dd/yyyy"
                                                        showMonthDropdown
                                                        showYearDropdown
                                                        selected={this.state.FromDate}
                                                        maxDate={this.state.ToDate}
                                                        onChange={(e) => this.OnHandleChange(e, "FromDate")}
                                                    //value={this.state.FromDate}
                                                    />
                                                    <span className="calendar-icon filter-calendar-icon custom-datepicker float-left" onClick={() => $(`#From`).focus()} />

                                                </div>
                                                <div className="col-md-6 float-left mb-4 pr-0 pl-1 ssd section-content-padding">
                                                    <label className="catalog-label">To <span className="info-container"><img className="info-searchpage" src="Images/info-icon.png" /><span className="info-content info-position"><Trans>date range is limited to 3 months</Trans></span></span></label>
                                                    <DatePicker className="form-control place "
                                                        id="To"
                                                        fixedHeight
                                                        placeholderText="MM/DD/YYYY"
                                                        dateFormat="MM/dd/yyyy"
                                                        showMonthDropdown
                                                        showYearDropdown
                                                        selected={this.state.ToDate}
                                                        minDate={this.state.FromDate}
                                                        onChange={(e) => this.OnHandleChange(e, "ToDate")}
                                                    //value={this.state.ToDate}
                                                    />
                                                    <span className="calendar-icon filter-calendar-icon custom-datepicker float-left" onClick={() => $(`#To`).focus()} />

                                                </div>
                                            </div>*/}
                                <div className="col-md-12">
                                    <div className="row">
                                        <div className="col-md-4 col-lg-3 mb-3" id="sdrp">
                                            <div className="input-group dropdown-search">
                                                <div className="input-group-prepend">
                                                    <button className="btn btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" >{this.state.SearchBy}</button>
                                                    <div className="dropdown-menu" style={{}}>
                                                        <a className="dropdown-item" href="#" onClick={(e) => this.OnHandleChange(e, "SearchBy", "PO ID")}><Trans>PO ID</Trans></a>
                                                        <a className="dropdown-item" href="#" onClick={(e) => this.OnHandleChange(e, "SearchBy", "Recv No")}><Trans>Recv.No</Trans></a>

                                                    </div>
                                                </div>

                                                <input type="text" className="form-control " placeholder="Search" aria-label="Text input with dropdown button" maxLength="10" value={this.state.SearchCriteria} onChange={e => this.OnHandleChange(e, "SearchCriteria")} id="SearchCriteriaid" onKeyDown={(e) => this.keyPressQTY(e)} />
                                                <span className={this.state.SearchCriteria != null && this.state.SearchCriteria != "" && this.state.SearchCriteria != " " ? "search-cancel-header cursor-pointer" : "d-none"} style={{ "right": '5px' }} onClick={() => this.clearItemId("SearchCriteria")}></span>
                                                {/*<div className="W-100 p-0 float-left mt-3">
                                                            <div className="custom-control custom-checkbox  mt-0 item-custom-control ml-0 float-left">
                                                                <input type="checkbox" className="custom-control-input" id="FirstPOOnly" name="FirstPOOnly" checked={this.state.UseDateRangeCheckbox} onChange={e => this.OnHandleChange(e, "UseDateRangeCheckbox")} />
                                                                <label className="custom-control-label" htmlFor="FirstPOOnly" />
                                                            </div>
                                                            <label className="catalog-label float-left mt-1 space-check " htmlFor="FirstPOOnly"><Trans>Use date range entered above to limit search</Trans></label>
                                                        </div>*/}
                                            </div>
                                        </div>
                                        <div className="col-md-6 col-lg-4 mb-3">
                                            <div className="row align-items-center">
                                                <label className="catalog-label col-md-5 col-lg-3 pr-0 mb-0" htmlFor="MfgPart"><Trans>Inv Item ID(Opt)</Trans></label>
                                                <div className="col-md-7 col-lg-7 pl-0">
                                                    <input type="text" maxLength={35} className="form-control" id="ItemIDid" maxLength="10" name="ItemID" value={this.state.ItemID} onChange={e => this.OnHandleChange(e, "ItemID")} onKeyDown={(e) => this.keyPressQTY(e)} />
                                                    <span className={this.state.ItemID != null && this.state.ItemID != "" && this.state.ItemID != " " ? "search-cancel-header cursor-pointer" : "d-none"} style={{ "right": '20px' }} onClick={() => this.clearItemId("ItemID")}></span>

                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-12 col-lg-3 col-sm-auto col-auto">
                                            <button className="btn btn-secondary custom-btn-secondary secondary-btn mr-2" onClick={this.Canclebutton}><Trans>Clear</Trans></button>
                                            <button className="btn btn-primary custom-btn-primary primary-btn" onClick={this.Applyfilter}><Trans>Apply</Trans><span> </span> <Trans>Filter</Trans></button>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-12">
                                    {this.state.ReturnPODetails.length > 0 ?
                                        <div className="table-responsive">
                                            <table className="table ZEUS_Grid FOM-grid chk-ordertbl">
                                                <thead>
                                                    <tr>
                                                        <th />
                                                        <th />
                                                        {/*<th className="d-none d-sm-none d-md-table-cell position-sort-icon"><Trans>Bu Rcv.</Trans><span className="sort-up ml-1" onClick={(e) => this.Sorting("ASC", "BUYER_ID")}><img src="Images/sort2.svg" /></span><span className="sort-down ml-1" onClick={(e) => this.Sorting("DESC", "BUYER_ID")}><img src="Images/sort1.svg" /></span></th>*/}
                                                        <th className="d-none d-sm-none d-md-table-cell position-sort-icon"><Trans>Item ID</Trans></th>
                                                        <th className="d-none d-sm-none d-md-table-cell position-sort-icon"><Trans>Recv No</Trans></th>
                                                        <th className="d-none d-sm-none d-md-table-cell position-sort-icon"><Trans>Recv Line</Trans></th>
                                                        {/*<th className="d-none d-sm-none d-md-table-cell position-sort-icon"><Trans>Bu PO</Trans><span className="sort-up ml-1" onClick={(e) => this.Sorting("ASC", "SHIPTO_ID")}><img src="Images/sort2.svg" /></span><span className="sort-down ml-1" onClick={(e) => this.Sorting("DESC", "SHIPTO_ID")}><img src="Images/sort1.svg" /></span></th>*/}
                                                        <th className="d-none d-sm-none d-md-table-cell position-sort-icon"><Trans>PO ID</Trans></th>
                                                        <th className="d-none d-sm-none d-md-table-cell position-sort-icon"><Trans>PO Line</Trans></th>
                                                        <th className="d-none d-sm-none d-md-table-cell position-sort-icon"><Trans>Sched</Trans></th>
                                                        <th className="d-none d-sm-none d-md-table-cell position-sort-icon"><Trans>PO</Trans></th>
                                                        <th className="d-none d-sm-none d-md-table-cell position-sort-icon"><Trans>Vendor ID</Trans></th>

                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {this.state.totalCount > 0 ? this.BindDataGrid() :
                                                        (

                                                            <tr>
                                                                <td colSpan={11}>
                                                                    <section className="site-undercontruction container text-center center-panel pt-4">
                                                                        <div className="img-section">
                                                                            <img src="images/nosearch.jpg" alt="imagefile" />
                                                                        </div>
                                                                        <p className="search-result-content pt-4"><Trans>Sorry, we couldn’t find any search result</Trans>
                                                                        </p>
                                                                    </section>
                                                                </td>
                                                            </tr>)}

                                                </tbody>
                                            </table>
                                            {this.state.ReturnPODetails.length > 0 ?
                                                <div className="col-md-12 ">
                                                    <span className="total-records mt-2 d-inline-block">
                                                        <Trans>Number of Records</Trans><span> :</span><span className="ml-2">{this.state.totalCount}</span>
                                                    </span>
                                                    {this.state.ReturnPODetails.length > 0 ? <ReactPaginate
                                                        previousLabel={<span className="right-pagination-arrow" />}
                                                        nextLabel={<span className="left-pagination-arrow" />}
                                                        previousClassName={'page-item'}
                                                        nextClassName={'page-item'}
                                                        previousLinkClassName={'page-link'}
                                                        nextLinkClassName={'page-link'}
                                                        disabledClassName={'disabled'}
                                                        breakLabel={'...'}
                                                        breakClassName={'page-item'}
                                                        breakLinkClassName={'page-link'}
                                                        pageCount={this.state.PageCount}
                                                        marginPagesDisplayed={1}
                                                        pageRangeDisplayed={2}
                                                        onPageChange={this.handlePageClick}
                                                        containerClassName={'custom-pagination pagination float-right'}
                                                        pageClassName={'page-item'}
                                                        pageLinkClassName={'page-link'}
                                                        activeClassName={'active'}
                                                        hrefBuilder={() => '#'}
                                                        forcePage={this.state.PageNo - 1}
                                                    /> : null}

                                                </div> : null}
                                        </div>
                                        : null}
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <div className="modal" id="Success-popup">
                    <div className="modal-dialog modal-md custom-popup modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-body text-center">
                                <div className="col-12 my-5">
                                    <img class="mb-2" src="images/tick.svg" alt="tick" />
                                    <label id="RMASucessMessage" className="confirm-content d-block"></label>
                                </div>

                                <div className="col-md-12 text-center mb-2">
                                    <button className="btn btn-primary custom-btn-primary primary-btn px-5" data-dismiss="modal" data-toggle="modal"><Trans>Ok</Trans></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )

    }

}
export default withTranslation()(RTVComponent);